module.exports = __webpack_public_path__ + "assets/img/calendar.93de1c45.svg";